import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import "./EmissionUpdate.scss";
import TextArea from "antd/es/input/TextArea";
import { bulkUploadService } from "../../../services/emissionService";
import ConfirmApproveDialog from "./ConfirmApproveDialog";
import { updateEmissionStatus } from "../../../services/emissionService";
import ConfirmRejectedDialog from "./ConfirmRejectedDialog";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const EmissionUpdate = (props: any) => {
  const {
    setOpenUpdate,
    updateStatusFormData,
    setUpdateStatusFormData,
    eachEmissionData,
    setemissionsList,
    emissionList,
    setEachEmissionData,
    getEmissionData,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const [isRejected, setIsRejected] = useState(false);
  const [scrollAmount, setScrollAmount] = useState(0);
  const [totalScrollWidth, setTotalScrollWidth] = useState(0);
  const [totalWindowWidth, setTotalWindowWidth] = useState(
    window.innerWidth * 0.9
  );
  const handleDeleteAttachments = (index: number) => {
    if (
      updateStatusFormData &&
      Object.keys(updateStatusFormData) &&
      updateStatusFormData.attachments?.length
    ) {
      const filteredData = updateStatusFormData?.attachments?.filter(
        (each: any, cid: any) => index !== cid
      );

      setUpdateStatusFormData({
        ...updateStatusFormData,
        attachments: [...filteredData],
      });
      if (filteredData?.length) {
        handleContainerWidthChange(filteredData.length);
      }
    }
  };

  const handleStatusUpdate = () => {
    const bunitId =
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id;
    const resultData = {
      emissionIds: [eachEmissionData.id],
      company:
        localStorage.getItem("company") &&
        JSON.parse(localStorage.getItem("company") || "").id,
      businessUnit: bunitId,
      fromValue: eachEmissionData.status,
      toValue: eachEmissionData.toStatus,
      comments: updateStatusFormData?.comments || "",
      attachments: {
        files: updateStatusFormData?.attachments || [],
      },
    };
    updateEmissionStatus(resultData)
      .then((res: any) => {
        console.log(res);
        if (res && res?.data?.success) {
          if (eachEmissionData?.from === "detailView") {
            const eachEmissions = eachEmissionData;
            eachEmissions.status = eachEmissionData.toStatus;
            setEachEmissionData(eachEmissions);
          }
          const prevEmissionList = emissionList;
          prevEmissionList[eachEmissionData.index].status =
            eachEmissionData.toStatus;
          setemissionsList(prevEmissionList);
          setUpdateStatusFormData({
            comments: "",
            attachments: [],
          });
          setOpenUpdate(false);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const imageSrc: string = "assets/images/doc.png";
  const getPreviewImage = (image: string) => {
    return image?.includes(".jpg") ||
      image?.includes(".jpeg") ||
      image?.includes(".png") ||
      image?.includes(".avif") ||
      image?.includes(".webp")
      ? image
      : imageSrc;
  };
  const getName = (file: any) => {
    if (!Object.keys(file)) return "";
    const extensionOfFile = file.originalName.slice(-4);
    const originalFileName = file.originalName?.split("-")[1];
    const splitedName = originalFileName.slice(0, originalFileName.length - 4);
    const requiredName = splitedName + extensionOfFile;
    const ans =
      requiredName?.length > 18
        ? requiredName.slice(0, 8) + "....." + extensionOfFile
        : requiredName;
    return ans;
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const handleDrop = (event: any) => {
    event.preventDefault();
    event.target.files = event.dataTransfer.files;
    handleChange(event);
  };
  const handleChange = (event: any) => {
    if (event.target.files?.length) {
      const tempformData = new FormData();
      tempformData.append("file", event.target.files[0]);
      bulkUploadService(tempformData).then((res: any) => {
        let resultData = {} as any;
        resultData.originalName = res.data.key;
        resultData.fileName = res.data.key;
        resultData.filePath = res.data.Location;
        setUpdateStatusFormData({
          ...updateStatusFormData,
          attachments: [...updateStatusFormData.attachments, resultData],
        });
      });
    }
    if (updateStatusFormData?.attachments?.length) {
      handleContainerWidthChange(updateStatusFormData.attachments.length + 1);
    }
  };
  const handleClick = () => {
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  const handleClose = () => {
    setUpdateStatusFormData({ Comment: "", attachments: [] });
    // setEachEmissionData({});
    setOpenUpdate(false);
  };
  const agreeFun = () => {
    handleStatusUpdate();
  };

  const handleStatusUpdateAction = () => {
    if (eachEmissionData?.toStatus === "Rejected") {
      setIsRejected(true);
    } else {
      handleStatusUpdate();
    }
  };
  const slider = useRef<HTMLDivElement | null>(null); // Explicitly type the ref
  const container = slider.current;
  const handleScroll = () => {
    if (container) {
      const currentScrollAmount = container.scrollLeft;
      setScrollAmount(currentScrollAmount);
    }
  };
  const handleContainerWidthChange = (value: any) => {
    if (value && container) {
      setTotalScrollWidth((value + 1) * 120 + (value + 1) * 12);
    }
  };
  useEffect(() => {
    if (container) {
      container.addEventListener("scroll", handleScroll);
      container.addEventListener("resize", () => {
        setTotalWindowWidth(window.innerWidth * 0.9);
      });
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [container]);
  const handleNext = () => {
    if (container) {
      container.scrollLeft += totalWindowWidth;
    }
  };
  const handlePrev = () => {
    if (container) {
      container.scrollLeft -= totalWindowWidth;
    }
  };

  const isNextButtonVisible = slider.current
    ? scrollAmount + slider.current.clientWidth < totalScrollWidth
    : false;

  const isPrevButtonVisible = scrollAmount > 0;
  return (
    <Fragment>
      <div className="pw-file-attachement-container">
        <Dialog className="pw-dialog-container-test" open={true}>
          <div className="pw-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">Update status</div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={handleClose}
                />
              </div>
            </div>

            <div className="flex justify-between items-center w-full mt-2">
              <div className="pw-color-neutral-900 text-sm">
                Are you sure you want to update the status from
                <span
                  className={`font-bold pw-${eachEmissionData?.status.toLowerCase()}-option pw-bg-neutral-200 pw-status-btn`}
                >
                  {" "}
                  {eachEmissionData?.status}
                </span>{" "}
                to{" "}
                <span
                  className={`font-bold pw-${eachEmissionData?.toStatus.toLowerCase()}-option pw-bg-primary-200 pw-status-btn`}
                >
                  {" "}
                  {eachEmissionData?.toStatus}
                </span>{" "}
              </div>
            </div>

            <div className="w-full mt-10">
              <div className="pw-color-neutral-600 text-sm">Add Comments</div>
              <TextArea
                value={updateStatusFormData?.comments}
                onChange={(e) =>
                  setUpdateStatusFormData({
                    ...updateStatusFormData,
                    comments: e.target.value,
                  })
                }
                placeholder="Comments"
                className="w-full pw-comments-field mt-2 p-4"
              />
              <div className="flex justify-end pw-color-neutral-400">0/100</div>
            </div>
            <div
              style={{ position: "relative" }}
              ref={slider}
              className="mt-10 w-full pw-hide-scroll  overflow-x-auto"
            >
              <div className="pw-color-neutral-600 text-sm">Attachments</div>
              <div className="w-full flex gap-x-2 mt-2 ">
                <div style={{ boxSizing: "border-box" }}>
                  {
                    <div
                      className={`pw-dragfile-attachments pw-margin-top-0 pw-p-12 flex flex-col items-center h-100 w-full  bg-white min-h-50v`}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    >
                      <div className="flex flex-col col-gap-35 items-center">
                        <div className="flex gap-x-1 whitespace-nowrap">
                          <FileUploadIcon className="pw-color-neutral-400" />
                          <div className="text-neutral-500 text-sm">
                            Drag and drop
                          </div>
                        </div>

                        <div className="flex flex-row justify-center gap-4 my-1 w-full">
                          <div className="text-sm text-neutral-500">OR</div>
                        </div>
                        <div className="pw-e2e-bulkimportoption pw-upload-container">
                          <input
                            type="file"
                            hidden
                            multiple
                            ref={inputRef}
                            onChange={handleChange}
                          />
                          <Button
                            className="pw-upload-button"
                            variant="outlined"
                            onClick={handleClick}
                          >
                            <FileUploadIcon className="pw-primary-color" />
                            <span className="pw-primary-color text-sm">
                              Upload
                            </span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                {updateStatusFormData &&
                  Object.keys(updateStatusFormData) &&
                  updateStatusFormData.attachments?.length > 0 &&
                  updateStatusFormData?.attachments?.map(
                    (each: any, index: any) => {
                      return (
                        <div className="pw-attachments-each-image pw-w-150 pw-h-135 flex flex-col">
                          <div className="pw-attachments-images">
                            <img src={getPreviewImage(each.filePath)} alt="" />
                          </div>
                          <div className="pw-attachments-files-name">
                            <div>{getName(each)}</div>
                          </div>
                          <div
                            onClick={() => handleDeleteAttachments(index)}
                            className={`pw-delete-icon-div`}
                          >
                            <img
                              src="assets/icons/trash-can.svg"
                              className="pw-color-red"
                            />
                          </div>
                        </div>
                      );
                    }
                  )}
                <Fragment>
                  {isNextButtonVisible && (
                    <div
                      onClick={() => handleNext()}
                      className="pw-next-btn flex justify-end pr-10 pw-top-45-percent"
                    >
                      <ArrowForwardIcon />
                    </div>
                  )}
                  {isPrevButtonVisible && (
                    <div
                      onClick={() => handlePrev()}
                      className="pw-next-btn pw-btn-back pw-top-45-percent  flex justify-start pl-10"
                    >
                      <ArrowBackIcon />
                    </div>
                  )}
                </Fragment>
              </div>
            </div>
          </div>
          <div className="flex flex-row mt-16 justify-end pw-bunit-footer w-full gap-6 mt-5">
            <div
              onClick={handleClose}
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
            >
              Cancel
            </div>
            <div
              onClick={handleStatusUpdateAction}
              className={`pw-bunit-button-primary pw-bunit-button-save text-white
               ${"cursor-pointer bg-primary"}`}
            >
              Update
            </div>
          </div>
        </Dialog>
        {isRejected && (
          <ConfirmRejectedDialog
            agreeFun={agreeFun}
            setIsRejected={setIsRejected}
          />
        )}
      </div>
    </Fragment>
  );
};

export default EmissionUpdate;
